/* global BINDERY_VERSION */
import { div } from '../dom';
export default (title, text) => {
    return div('.error', div('.error-title', title), div('.error-text', text), div('.error-footer', `Bindery ${BINDERY_VERSION}`));
};
